
/* INT: Wishlist landing — after the pressed-heart burst finishes, a heart
   materialises above the header wishlist icon and flies down into it, then the
   icon pulses. Driven once per add by window.__intHeartLand. Append-only. */
(function () {
  if (window.__intHeartLandInit) return;
  window.__intHeartLandInit = true;

  var TARGET   = '[data-intention-wishlist], #intention-wishlist-mobile, #intention-wishlist, .header__desktop__button--wishlist, .header__mobile__button--wishlist'; /* desktop + mobile; the visible one is chosen at fire time */
  var BURST_MS = 650;     /* delay after the burst before launching */
  var RISE     = 90;      /* how far above the icon the heart appears (px) */
  var FLY_MS   = 700;     /* flight duration (ms) */
  var COUNT    = 7;       /* how many hearts stream into the icon */
  var SPREAD   = 46;      /* funnel width at the top (px) */
  var STAGGER  = 70;      /* ms between each heart launch */
  var COLOR    = '#00FFBF';

  var HEART = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">'
    + '<path d="M12 21s-7.6-4.8-10.1-9.2C-.2 8.3 1.6 4.6 5.3 4.6c2 0 3.5 1.1 4.7 2.6 '
    + '1.2-1.5 2.7-2.6 4.7-2.6 3.7 0 5.5 3.7 3.4 7.2C19.6 16.2 12 21 12 21z" fill="' + COLOR + '"/></svg>';

  function injectCSS() {
    if (document.getElementById('int-heart-land-css')) return;
    var st = document.createElement('style');
    st.id = 'int-heart-land-css';
    st.textContent =
      '.int-heart-land{position:fixed!important;z-index:2147483646!important;pointer-events:none!important;width:22px!important;height:22px!important;opacity:0;will-change:transform,opacity!important;}'
      + '.int-heart-land svg{display:block!important;width:100%!important;height:100%!important;}';
    document.head.appendChild(st);
  }

  function pulse(el) {
    try {
      el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }],
        { duration: 320, easing: 'ease-out' });
    } catch (e) {}
  }

  function fly() {
    /* Pick the VISIBLE header icon. The mobile node is in the DOM but
       display:none on desktop (rect 0x0) and vice-versa; querySelector grabbed
       whichever came first, and a 0x0 rect made fly() bail silently — the no-fire. */
    var nodes = document.querySelectorAll(TARGET), target = null, r = null;
    for (var i = 0; i < nodes.length; i++) {
      var rect = nodes[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) { target = nodes[i]; r = rect; break; }
    }
    if (!target) return;
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;

    injectCSS();

    var n = COUNT + Math.floor(Math.random() * 3); /* a few, varied each fire */
    var landed = 0;
    function onLanded() { landed++; if (landed === 1) pulse(target); }

    for (var k = 0; k < n; k++) {
      (function (idx) {
        var h = document.createElement('div');
        h.className = 'int-heart-land';
        h.innerHTML = HEART;
        h.style.left = cx + 'px';
        h.style.top = cy + 'px';
        document.body.appendChild(h);

        /* Funnel: each heart starts spread out and high, then converges to the
           icon centre as it falls. Staggered so they stream in one after another
           like the product-heart burst, but inward. */
        var dx    = (Math.random() * 2 - 1) * SPREAD;
        var rise  = RISE + (Math.random() * 2 - 1) * 20;
        var s0    = 0.7 + Math.random() * 0.5;
        var rot   = (Math.random() * 2 - 1) * 24;
        var delay = idx * STAGGER + Math.random() * 60;
        var dur   = FLY_MS + (Math.random() * 2 - 1) * 120;

        var done = false;
        function cleanup() { if (done) return; done = true; h.remove(); onLanded(); }

        try {
          var a = h.animate([
            { transform: 'translate(-50%,-50%) translate(' + dx + 'px,-' + rise + 'px) scale(' + s0 + ') rotate(' + rot + 'deg)', opacity: 0, offset: 0 },
            { transform: 'translate(-50%,-50%) translate(' + (dx * 0.5) + 'px,-' + (rise * 0.5) + 'px) scale(' + s0 + ') rotate(' + (rot * 0.5) + 'deg)', opacity: 1, offset: 0.3 },
            { transform: 'translate(-50%,-50%) translate(0px,0px) scale(0.3) rotate(0deg)', opacity: 0, offset: 1 }
          ], { duration: dur, delay: delay, easing: 'cubic-bezier(0.45,0,0.55,1)', fill: 'both' });
          a.onfinish = cleanup;
          a.oncancel = cleanup;
        } catch (e) {
          setTimeout(cleanup, dur + delay);
        }
      })(k);
    }
  }

  window.__intHeartLand = function () { setTimeout(fly, BURST_MS); };
})();

;

(function () {
  /* Double fire guard, 2026-10-03: collapse a second /cart/add only when it is the SAME
     add (same variant ids and quantities) inside the window. A different variant goes
     through. The earlier version answered ANY second add with the first response and
     lost one piece when two products were added within 900 ms. */
  var WINDOW = 900, last = { t: 0, key: null, resp: null };

  function addKey(body) {
    try {
      if (body == null) return 'none';
      var pairs = [];
      function push(id, q) { pairs.push(String(id) + ':' + String(q == null || q === '' ? 1 : q)); }
      if (typeof body === 'string') {
        var t = body.replace(/^\s+/, '');
        if (t.charAt(0) === '{' || t.charAt(0) === '[') {
          var j = JSON.parse(t);
          if (j && j.items && j.items.length) { for (var i = 0; i < j.items.length; i++) push(j.items[i].id, j.items[i].quantity); }
          else if (j && j.id != null) push(j.id, j.quantity);
          else return 'json:' + t;
        } else {
          var sp = new URLSearchParams(t);
          if (sp.has('id')) push(sp.get('id'), sp.get('quantity')); else return 'form:' + t;
        }
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        if (body.has('id')) push(body.get('id'), body.get('quantity')); else return 'form:' + body.toString();
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.has('id')) {
          var ids = body.getAll('id'), qs = body.getAll('quantity');
          for (var k = 0; k < ids.length; k++) push(ids[k], qs[k] != null ? qs[k] : qs[0]);
        } else return 'formdata:unknown';
      } else {
        return 'other:' + Object.prototype.toString.call(body);
      }
      pairs.sort();
      return pairs.join(',');
    } catch (e) { return 'unparsed'; }
  }

  function sameAdd(key, now) {
    return last.key !== null && last.key === key && (now - last.t) < WINDOW;
  }

  // Guard fetch-based adds (theme product-form, Rebuy, etc.)
  var of = window.fetch;
  window.fetch = function () {
    var args = arguments, u = args[0], o = args[1] || {};
    var url = (typeof u === 'string' ? u : (u && u.url)) || '';
    var method = o.method || (u && u.method) || 'GET';
    var isAdd = url.indexOf('/cart/add') > -1 && String(method).toUpperCase() === 'POST';
    if (isAdd) {
      var now = Date.now();
      var key = (o.body !== undefined) ? addKey(o.body) : 'request:' + url;
      if (last.resp && sameAdd(key, now)) { return last.resp.then(function (r) { return r.clone(); }); }
      var p = of.apply(this, args);
      last = { t: now, key: key, resp: p.then(function (r) { return r.clone(); }) };
      return p;
    }
    return of.apply(this, args);
  };

  // Guard XHR-based adds (in case a second handler uses XHR)
  var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__intAdd = String(u || '').indexOf('/cart/add') > -1 && String(m || '').toUpperCase() === 'POST';
    return oOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__intAdd) {
      var now = Date.now();
      var key = addKey(body);
      if (sameAdd(key, now)) { try { this.abort(); } catch (e) {} return; }
      last = { t: now, key: key, resp: null };
    }
    return oSend.apply(this, arguments);
  };
})();
